import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROUTING, PATH } from '../../../constants';
import './About.css';

class About extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div id="about">
        <div className="head">
          O projektu
        </div>
        <div className="logo-wrap logo-100">
          <img
            className="logo"
            src={`${PATH.IMG}about/logo-100.png`}
            alt="Toto100letí"
          />
        </div>
        <div className="title">
          Dramaturgie, produkce, grafika, webdesign, programování, rešerše – Centrum dramaturgie nových médií ČT:
        </div>
        <div className="content">
          Eva Burachovičová, Josef Duda, Jiří Koukal, Milan Marčák, Rebeka Maxová, Filip Smetana, Veronika Součková, Kateřina Sudolská, Štěpánka Sunková, Petr Vogl, Kristina Volná
        </div>
        <div className="title">
          Rešerše:
        </div>
        <div className="content">
          Matěj Čermák, Matěj Fixl, Tomáš Kolich, Max Kynčl, Daniel Kyselka, Karel Matějka, Jitka Nováková
        </div>
        <div className="title">
          Archiv České televize:
        </div>
        <div className="content">
          Jakub Adamus, Edgar Holländer, Marie Mrkusová, Iva Syslová
        </div>
        <div className="title">
          Články ČT24:
        </div>
        <div className="content">
          tým redakce ČT 24, tým redakce ČT sport, Karel Tinl, Aleš Měřička
        </div>
        <div className="title">
          Odborný poradce:
        </div>
        <div className="content">
          Jakub Jareš
        </div>
        <div className="title">
          Znělky TOTO 100 LETÍ:
        </div>
        <div className="content">
          <h4>Režie:</h4>
          <div>Janek Jirků</div>
          <h4>Střih:</h4>
          <div>Zdeněk Durdil, Josef Karel Hlavatý</div>
          <h4>Produkce:</h4>
          <div>Magda Gärtnerová, Zdeněk Hala</div>
          <h4>Výtvarnice:</h4>
          <div>Barbora Kafková, Adéla Kostkanová</div>
          <h4>Světlo:</h4>
          <div>Karel Kaliban</div>
          <h4>Kamera:</h4>
          <div>Petr Vejslík</div>
        </div>
        <div className="title">
          Nahrávky pamětníků:
        </div>
        <div className="content">
          Paměť národa
        </div>
        <a
          className="logo-wrap logo-memory"
          href="http://www.pametnaroda.cz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="logo"
            src={`${PATH.IMG}about/logo-memory.png`}
            alt="Logo Paměť národa"
          />
        </a>
        <div className="title">
          TOTO100LETÍ ve škole:
        </div>
        <div className="content">
          Ústav pro studium totalitních režimů, oddělení vzdělávání
        </div>
        <a
          className="logo-wrap logo-ustr"
          href="https://www.ustrcr.cz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="logo"
            src={`${PATH.IMG}about/logo-ustr.png`}
            alt="Logo ÚSTR"
          />
        </a>
        <a
          className="logo-wrap logo-ustr"
          href="http://dejepis21.cz/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="logo"
            src={`${PATH.IMG}about/logo-21.png`}
            alt="Logo D21"
          />
        </a>
        <div className="title">
          Budeme rádi za vaše dotazy a připomínky:
        </div>
        <div className="content">
          <a
            href="mailto:toto100leti@ceskatelevize.cz"
          >
            toto100leti@ceskatelevize.cz
          </a>
        </div>
        <div className="content">
          <Link
            className="link-source-list"
            to={ROUTING.ARCHIVE_LIST}
          >
            Seznam použitých zdrojů z archivu ČT
          </Link>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/App/About/About.js